import { Button, ButtonProps, Spinner, makeStyles } from "@fluentui/react-components";

interface IAppButton {
  text: string;
  disabled?: boolean
}
const useStyles = makeStyles({
  button: {
    maxHeight: "2rem",
  },
  spinner: {
    marginRight: ".5rem"
  } 
});

export default function AppButton(props: IAppButton & ButtonProps) {
  const { text, disabled, ...rest } = props;
  const styles = useStyles();
  return (
    <Button 
      className={styles.button} 
      appearance="primary" 
      disabled = {disabled} 
      {...rest} 
    >
      {disabled && <Spinner size="tiny" className={styles.spinner}/>}
      {text}
    </Button>
  );
}
